import React from "react";
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Box,
  IconButton,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

import { ReadMoreText } from "../../../views/marketingCampaign/components/ReadMoreText";
import { IWhatsAppTemplateData } from "../../../redux/whatsappTemplate/whatsappTemplate.types";

interface RecommendedTemplatesTableProps {
  templates: IWhatsAppTemplateData[];
  onTemplateAdd: (template: IWhatsAppTemplateData) => void;
  onTemplatePreview?: (template: IWhatsAppTemplateData) => void;
}

export const RecommendedTemplatesTable: React.FC<
  RecommendedTemplatesTableProps
> = ({ templates, onTemplateAdd, onTemplatePreview }) => {
  const [openView, setOpenView] = React.useState<IWhatsAppTemplateData | null>(
    null
  );

  return (
    <>
      <TableContainer sx={{ mt: 4 }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "primary.main" }}>
              <TableCell
                sx={{
                  color: "#fff",
                  fontSize: "0.95rem",
                  fontWeight: 500,
                }}
              >
                Add
              </TableCell>
              {/* <TableCell
                sx={{
                  color: "#fff",
                  fontSize: "0.95rem",
                  fontWeight: 500,
                  minWidth: "100px",
                }}
              >
                Actions
              </TableCell> */}
              <TableCell
                sx={{
                  color: "#fff",
                  fontSize: "0.95rem",
                  fontWeight: 500,
                  minWidth: "200px",
                }}
              >
                Template Name
              </TableCell>
              <TableCell
                sx={{
                  color: "#fff",
                  fontSize: "0.95rem",
                  fontWeight: 500,
                  minWidth: "100px",
                }}
              >
                Header
              </TableCell>
              <TableCell
                sx={{
                  color: "#fff",
                  fontSize: "0.95rem",
                  fontWeight: 500,
                  minWidth: "200px",
                }}
              >
                Body
              </TableCell>
              <TableCell
                sx={{
                  color: "#fff",
                  fontSize: "0.95rem",
                  fontWeight: 500,
                  minWidth: "200px",
                }}
              >
                Footer
              </TableCell>
              <TableCell
                sx={{
                  color: "#fff",
                  fontSize: "0.95rem",
                  fontWeight: 500,
                  minWidth: "200px",
                }}
              >
                Buttons
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {templates.map((template, index) => (
              <TableRow
                key={index}
                hover
                onClick={() => onTemplatePreview?.(template)}
                sx={{ cursor: "pointer" }}
              >
                <TableCell onClick={(e) => e.stopPropagation()}>
                  <IconButton
                    onClick={() => onTemplateAdd(template)}
                    sx={{
                      color: "primary.main",
                    }}
                  >
                    <AddIcon />
                  </IconButton>
                </TableCell>
                {/* <TableCell onClick={(e) => e.stopPropagation()}>
                  <StandardTableActions
                    onViewClick={() => setOpenView(template)}
                  />
                </TableCell> */}
                <TableCell>{template.name}</TableCell>
                <TableCell>
                  {template.header?.text || template.header?.format || "--"}
                </TableCell>
                <TableCell>
                  {(() => {
                    return (
                      <ReadMoreText
                        text={template.body.text}
                        maxLines={2}
                        variant="body2"
                      />
                    );
                  })()}
                </TableCell>
                <TableCell>{template.footer?.text || "--"}</TableCell>
                <TableCell>
                  {template.buttons?.buttons &&
                  template.buttons.buttons.length > 0
                    ? template.buttons.buttons
                        .map((button) => button.text)
                        .join(", ")
                    : "--"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};
